// extracted by mini-css-extract-plugin
export default {"bedOptionsContainer":"bed_options_bedOptionsContainer__K-bcu"};